import ChangeThumbnailModal from "./ChangeThumbnailModal";

export default ChangeThumbnailModal